import fetchJsonp from 'fetch-jsonp';
import { DateTime } from 'luxon';

import Exception from '@/common/models/Exception';
import { BaiduMapsApiKey } from '@/globals';
import orgAppApi from '@/org-app/api';
import LocalCache from '@/utils/LocalCache';

const PlaceSearchUrl = `https://api.map.baidu.com/place/v2/search?city_limit=true&output=json&scope=2&page_size=20&ak=${BaiduMapsApiKey}`;

export default class PlaceSearchEngineBaidu {
  constructor() {
    this.places = [];
    this.searchTerm = '';
    this.cacheKey = null;
  }

  increaseRequestsCount() {
    if (this.requestsCount < this.requestsCountLimit) {
      this.requestsCount += 1;
      return true;
    }
    return false;
  }

  increaseCompletedRequestsCount() {
    this.completedRequestsCount += 1;
    return this.requestsCount === this.completedRequestsCount;
  }

  async mapResultsToBuilding(places) {
    const coordinates = places.map((x) => [x.location.lat, x.location.lng]);
    const result = await orgAppApi.instance.getBuildingsAtCoordinates(coordinates);
    result.forEach((x, i) => {
      if (x != null) {
        places[i].geoJson = x;
      }
    });
    return places;
  }

  async searchPlaces(searchTerm, usePolygons = true) {
    this.cacheKey = `placeSearchResults-${searchTerm}`;
    const cachedResults = LocalCache.get(this.cacheKey);
    if (cachedResults != null && cachedResults.length > 0) {
      if (!usePolygons) {
        return cachedResults;
      }
      const places = await this.mapResultsToBuilding(cachedResults);
      return places;
    }

    this.requestsCount = 0;
    this.completedRequestsCount = 0;
    this.searchTerm = searchTerm;
    if (searchTerm == null || searchTerm.trim() === '') {
      throw new Exception('Invalid search term');
    }

    let area = null;
    let placeName = null;
    if (this.searchTerm.indexOf('的') > -1) {
      [area] = this.searchTerm.split('的');
      [, placeName] = this.searchTerm.split('的');
    } else if (this.searchTerm.indexOf(' in ') > -1) {
      [placeName] = this.searchTerm.split(' in ');
      [, area] = this.searchTerm.split(' in ');
    } else {
      return [];
    }

    this.places.splice(0, this.places.length);
    let result = await fetchJsonp(`${PlaceSearchUrl}&query=${placeName}&region=${area}&page_num=0`);
    result = await result.json();

    this.places = result.results;

    const promises = [];
    for (let i = 1; i < result.total / 20; i += 1) {
      promises.push(this.getMoreResult(placeName, area, i));
    }
    await Promise.all(promises);

    const [firstResult] = result.results;
    if (firstResult == null) {
      return [];
    }

    LocalCache.set(this.cacheKey, this.places, DateTime.local().plus({ hours: 24 })); // 24 hours cache
    if (!usePolygons) {
      return this.places;
    }
    const places = await this.mapResultsToBuilding(this.places);
    return places;
  }

  async getMoreResult(placeName, area, pageNum) {
    let moreResult = await fetchJsonp(`${PlaceSearchUrl}&query=${placeName}&region=${area}&page_num=${pageNum}`);
    moreResult = await moreResult.json();
    this.places.push(...moreResult.results);
  }
}
